document.addEventListener("DOMContentLoaded", function () {
  const lightboxes = document.querySelectorAll("[data-lightbox]");
  const header = document.getElementById("header-outer");


  lightboxes.forEach((lightbox) => {
    const triggerButton = document.querySelector(
      `[data-lightbox-trigger='${lightbox.dataset.lightbox}']`
    );
    const closeButton = lightbox.querySelector("[data-lightbox-close]");
    const popup = lightbox.querySelector(".o-html5-video");
    const video = lightbox.querySelector("video");
    const body = document.body;
    const html = document.documentElement;

    const closeLightbox = () => {
      lightbox.classList.add("hidden");
      body.classList.remove("is-light-box-open");
      html.classList.remove("no-scroll");
      header.classList.add("scrolled-up"); 
      if (video && !video.paused) {
        video.pause();
      }
    };

    if (triggerButton) {
      triggerButton.addEventListener("click", function () {
        lightbox.classList.remove("hidden");
        body.classList.add("is-light-box-open");
        html.classList.add("no-scroll");
        header.classList.remove("scrolled-up"); 
      });
    }

    if (closeButton) {
      closeButton.addEventListener("click", closeLightbox);
    }

    lightbox.addEventListener("click", function (e) {
      if (!popup.contains(e.target)) {
        closeLightbox();
      }
    });
  });
});
